export default __webpack_public_path__ + "static/media/Profile.36a85094.jpg";